import { setupNextraPage } from 'nextra/setup-page'
import __nextra_layout from 'nextra-theme-docs'
import __nextra_themeConfig from 'E:/pocket-tool/.pocket-doc/theme.config.tsx'

import 'nextra-theme-docs/style.css'
/*@jsxRuntime automatic @jsxImportSource react*/
// 多选
// 单选
import {useMDXComponents as _provideComponents} from "nextra/mdx";
import InitMenu from "../../src/components/InitMenu";
import React, {useRef, useState} from "react";
import {Table, TableHead, TableRow, TableBody, TableCell} from "pocko-ui/Table";
import 'pocko-ui/Table/index.css';
import Checkbox from 'pocko-ui/Checkbox';
export const Demo = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  return <>
      <_components.div className="mt-4">
        <Table tableClassName="table table-hover table-bordered table-striped align-middle">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Title 1</TableCell>
              <TableCell>Title 2</TableCell>
              <TableCell>Title 3</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Jason</TableCell>
              <TableCell>Jason 2</TableCell>
              <TableCell>Jason 3</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Pray</TableCell>
              <TableCell>Pray 2</TableCell>
              <TableCell>Pray 3</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell colSpan="2">Neme</TableCell>
              <TableCell>Neme 2</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </_components.div>
    </>;
};
export const Demo1 = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  return <>
      <_components.div className="mt-4">
        <Table cellAutoWidth tableClassName="table table-hover table-bordered table-striped align-middle">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Title 1</TableCell>
              <TableCell>Title 2</TableCell>
              <TableCell>Title 3</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Jason</TableCell>
              <TableCell>Jason 2</TableCell>
              <TableCell>Jason 3-Jason 3-Jason 3-Jason 3</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Pray</TableCell>
              <TableCell>Pray 2</TableCell>
              <TableCell>Pray 3</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell colSpan="2">Neme</TableCell>
              <TableCell>Neme 2</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </_components.div>
    </>;
};
export const Demo2 = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  return <>
      <_components.div className="mt-4 to-table-responsive_iframe" style={{
    height: '100px'
  }}>
        <Table tableClassName="table table-hover table-bordered table-striped align-middle">
          <TableHead className="sticky-top bg-white">
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Title 1</TableCell>
              <TableCell>Title 2</TableCell>
              <TableCell>Title 3</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>1</TableCell>
              <TableCell>Jason</TableCell>
              <TableCell>Jason 2</TableCell>
              <TableCell>Jason 3-Jason 3-Jason 3-Jason 3</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>2</TableCell>
              <TableCell>Pray</TableCell>
              <TableCell>Pray 2</TableCell>
              <TableCell>Pray 3</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>3</TableCell>
              <TableCell colSpan="2">Neme</TableCell>
              <TableCell>Neme 2</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </_components.div>
    </>;
};
export const Demo3 = () => {
  const _components = Object.assign({
    div: "div"
  }, _provideComponents());
  const testData = [{
    id: "1",
    name: "OIE19010",
    friend: "OIE19022",
    condition: "PERFECT"
  }, {
    id: "2",
    name: "OIE19022",
    friend: "OIE19061",
    condition: "PERFECT"
  }, {
    id: "3",
    name: "OIE19061",
    friend: "SWE19048",
    condition: "PERFECT"
  }, {
    id: "4",
    name: "SWE19048",
    friend: "OIE19010",
    condition: "PERFECT"
  }];
  const [tableData, setTableData] = useState([]);
  // 多选
  function handleSelectAll() {
    const isAllSelected = testData.every(item => tableData.some(selectedItem => selectedItem.id == item.id));
    if (isAllSelected) {
      setTableData([]);
    } else {
      const unselectedItems = testData.filter(item => !tableData.some(selectedItem => selectedItem.id == item.id));
      setTableData(prevChoose => [...prevChoose, ...unselectedItems]);
    }
  }
  // 单选
  function isChoose(e, val) {
    const index = tableData.findIndex(item => item.id == val.id);
    if (index != -1) {
      const updatedChoose = [...tableData];
      updatedChoose.splice(index, 1);
      setTableData(updatedChoose);
    } else {
      setTableData(prevChoose => [...prevChoose, val]);
    }
  }
  return <>
      <_components.div className="mt-4 to-table-responsive_iframe">
        <Table tableClassName="table table-hover table-bordered table-striped align-middle">
          <TableHead className="sticky-top bg-white">
            <TableRow>
              <TableCell>
                <Checkbox wrapperClassName="mb-0" onChange={handleSelectAll} checked={tableData.length == testData.length} />
              </TableCell>
              <TableCell>name</TableCell>
              <TableCell>friend</TableCell>
              <TableCell>condition</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {testData.map((v, i) => {
    return <TableRow key={i}>
                  <TableCell>
                    <Checkbox value={v} wrapperClassName="mb-0" onChange={(e, val) => {
      isChoose(e, val);
    }} checked={tableData.some(selectedItem => selectedItem.id == v.id)} />
                  </TableCell>
                  <TableCell>{v.name}</TableCell>
                  <TableCell>{v.friend}</TableCell>
                  <TableCell>{v.condition}</TableCell>
                </TableRow>;
  })}
          </TableBody>
        </Table>
      </_components.div>
    </>;
};
export const __toc = [{
  depth: 4,
  value: "General",
  id: "general"
}, {
  depth: 4,
  value: "Cell Auto Width",
  id: "cell-auto-width"
}, {
  depth: 4,
  value: "Sticky Table Headers",
  id: "sticky-table-headers"
}, {
  depth: 4,
  value: "Row selection (multiple rows)",
  id: "row-selection-multiple-rows"
}, {
  depth: 4,
  value: "API",
  id: "api"
}, {
  depth: 5,
  value: "Table",
  id: "table"
}, {
  depth: 5,
  value: "TableHead",
  id: "tablehead"
}, {
  depth: 5,
  value: "TableBody",
  id: "tablebody"
}, {
  depth: 5,
  value: "TableRow",
  id: "tablerow"
}, {
  depth: 5,
  value: "TableCell",
  id: "tablecell"
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h4: "h4",
    p: "p",
    strong: "strong",
    details: "details",
    summary: "summary",
    pre: "pre",
    code: "code",
    span: "span",
    blockquote: "blockquote",
    ul: "ul",
    li: "li",
    h5: "h5",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, _provideComponents(), props.components);
  return <><InitMenu />{"\n"}<_components.h1>{"Table"}</_components.h1>{"\n"}{"\n"}<_components.h4 id="general">{"General"}</_components.h4>{"\n"}<hr />{"\n"}<_components.p><_components.strong>{"Table"}</_components.strong><br />{"\r\nA table displays rows of data."}</_components.p>{"\n"}{"\n"}<Demo />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  Table"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Table\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"tableClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"table table-hover table-bordered table-striped align-middle\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">#</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Pray</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Pray 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Pray 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"colSpan"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Neme</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Neme 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="cell-auto-width">{"Cell Auto Width"}</_components.h4>{"\n"}<_components.p>{"The table displays data rows with adaptive width based on content"}</_components.p>{"\n"}{"\n"}<Demo1 />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  Table"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Table\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cellAutoWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"tableClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"table table-hover table-bordered table-striped align-middle\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">#</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 3-Jason 3-Jason 3-Jason 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"colSpan"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Neme</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Neme 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="sticky-table-headers">{"Sticky Table Headers"}</_components.h4>{"\n"}{"\n"}<Demo2 />{"\n"}<_components.details><_components.summary><i className="fa-brands fa-css3-alt px-2" />{" Show Code ["}<strong>{"Index.scss"}</strong>{"]"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".table_className {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  table"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"layout"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" auto;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" max"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"content;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  min"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"100"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"%"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".to"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"table"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"responsive_iframe {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  overflow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" auto;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"100"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"%"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  position"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" relative;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"::"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"webkit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"scrollbar {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    height"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" 15px;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    width"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" 10px;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    background"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"color"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" #e4e4e4;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"::"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"webkit"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"scrollbar"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"thumb {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    background"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"color"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" #ccc;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    border"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"radius"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" 10px;"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"&"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{":hover {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      background"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"color"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" #aaa;"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line">{" "}</_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.details><_components.summary><i className="fa-brands fa-js px-2" />{" Show Code ["}<strong>{"Index.tsx"}</strong>{"]"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  Table"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Table\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'./Index.scss'"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"style"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{{height"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'100px'"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" overflow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'scroll'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}}>  "}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"cellAutoWidth"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"tableClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"table table-hover table-bordered table-striped align-middle\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">#</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Title 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">1</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Jason 3-Jason 3-Jason 3-Jason 3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">3</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"colSpan"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Neme</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">Neme 2</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="row-selection-multiple-rows">{"Row selection (multiple rows)"}</_components.h4>{"\n"}{"\n"}<Demo3 />{"\n"}<_components.details><_components.summary>{"Show Code"}</_components.summary><_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" React"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { useRef"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" useState } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"react\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  Table"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"} "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Table\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" Checkbox "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"pocko-ui/Checkbox\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"; "}</_components.span><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"//other components"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"testData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"1\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19010\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" friend"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19022\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" condition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"PERFECT\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"2\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19022\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" friend"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19061\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" condition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"PERFECT\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"3\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19061\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" friend"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"SWE19048\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" condition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"PERFECT\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  { id"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"4\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" name"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"SWE19048\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" friend"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"OIE19010\""}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" condition"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"PERFECT\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" }"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"];"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"tableData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"setTableData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"] "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"useState"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"<"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"[]>([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 多选"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"handleSelectAll"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"() {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"isAllSelected"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"testData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".every"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"tableData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".some"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((selectedItem"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"selectedItem"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  );"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (isAllSelected) {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setTableData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"([]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"unselectedItems"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"testData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".filter"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      (item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"tableData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".some"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((selectedItem) "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"selectedItem"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id)"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    );"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setTableData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((prevChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"..."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"prevChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"..."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"unselectedItems]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-comment)"
  }}>{"// 单选"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"function"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"isChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"index"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"tableData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".findIndex"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((item"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"item"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"val"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id);"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"if"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" (index "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"!="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"-"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"const"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"updatedChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"..."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"tableData];"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"updatedChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".splice"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(index"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"1"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setTableData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(updatedChoose);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"else"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"setTableData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((prevChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ["}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"..."}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"prevChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val]);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  }"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  <>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mt-4 to-table-responsive_iframe\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"tableClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"table table-hover table-bordered table-striped align-middle\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"className"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"sticky-top bg-white\""}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"              <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-0\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{handleSelectAll}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"tableData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"length"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"testData"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"."}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"length"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"              />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">name</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">friend</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">condition</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableHead"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line">{" "}</_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          {"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"testData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".map"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"((v"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" i"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"return"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" ("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"              <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"key"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{i}>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                  <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Checkbox"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"value"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{v}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"wrapperClassName"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"\"mb-0\""}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"onChange"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" {"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                      "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"isChoose"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"(e"}</_components.span><_components.span style={{
    color: "var(--shiki-token-punctuation)"
  }}>{","}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" val);"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    }}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    "}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{"checked"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"tableData"}</_components.span><_components.span style={{
    color: "var(--shiki-token-function)"
  }}>{".some"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"("}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                      (selectedItem"}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{":"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"any"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{") "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=>"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"selectedItem"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"=="}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".id"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                    )}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                  />"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".name}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".friend}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"                <"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">{"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"v"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{".condition}</"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableCell"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"              </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableRow"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"            );"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"          })}"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"        </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"TableBody"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"      </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-constant)"
  }}>{"Table"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"    </"}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"div"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{">"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{"  </>"}</_components.span></_components.span>{"\n"}<_components.span className="line"><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{");"}</_components.span></_components.span></_components.code></_components.pre></_components.details>{"\n"}<_components.h4 id="api">{"API"}</_components.h4>{"\n"}<hr />{"\n"}<_components.blockquote>{"\n"}<_components.p>{"You could specify all remaining properties defined and all synthetic events from React on all components listed below. such as tabIndex, style, id, data-xxx, onClick, onMouseEnter, onMouseLeave, and so on."}</_components.p>{"\n"}</_components.blockquote>{"\n"}<_components.ul>{"\n"}<_components.li><_components.code>{"<Table />"}</_components.code></_components.li>{"\n"}<_components.li><_components.code>{"<TableHead />"}</_components.code></_components.li>{"\n"}<_components.li><_components.code>{"<TableBody />"}</_components.code></_components.li>{"\n"}<_components.li><_components.code>{"<TableRow />"}</_components.code></_components.li>{"\n"}<_components.li><_components.code>{"<TableCell />"}</_components.code></_components.li>{"\n"}</_components.ul>{"\n"}<_components.h5 id="table">{"Table"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { Table } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Table'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"tableWrapperClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the outer div of the table."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"tableClassName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"'table'"}</_components.td><_components.td>{"The style name of the table."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"cellAutoWidth"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether the table adjusts its width automatically."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"hover"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"true"}</_components.td><_components.td>{"To enable a hover state on table rows."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"bordered"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"true"}</_components.td><_components.td>{"Whether the table has borders."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"children"}</_components.code></_components.td><_components.td>{"React.ReactNode"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The content inside the table."}</_components.td><_components.td>{"✔"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h5 id="tablehead">{"TableHead"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { TableHead } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Table'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"className"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the table head."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"ref"}</_components.code></_components.td><_components.td>{"React.ForwardedRef"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It is the return element of this component."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h5 id="tablebody">{"TableBody"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { TableBody } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Table'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"className"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the table body."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"ref"}</_components.code></_components.td><_components.td>{"React.ForwardedRef"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It is the return element of this component."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h5 id="tablerow">{"TableRow"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { TableRow } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Table'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"className"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the table body."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"ref"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"It is the return element of this component."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"active"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether this cell row is highlight."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"activeName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the table row highlight."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table>{"\n"}<_components.h5 id="tablecell">{"TableCell"}</_components.h5>{"\n"}<_components.pre data-language="js" data-theme="default" hasCopyCode><_components.code data-language="js" data-theme="default"><_components.span className="line"><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"import"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" { TableCell } "}</_components.span><_components.span style={{
    color: "var(--shiki-token-keyword)"
  }}>{"from"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{" "}</_components.span><_components.span style={{
    color: "var(--shiki-token-string-expression)"
  }}>{"'pocko-ui/Table'"}</_components.span><_components.span style={{
    color: "var(--shiki-color-text)"
  }}>{";"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.table><_components.thead><_components.tr><_components.th>{"Property"}</_components.th><_components.th>{"Type"}</_components.th><_components.th>{"Default"}</_components.th><_components.th>{"Description"}</_components.th><_components.th>{"Required"}</_components.th></_components.tr></_components.thead><_components.tbody><_components.tr><_components.td><_components.code>{"className"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the table body."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"active"}</_components.code></_components.td><_components.td>{"boolean"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Whether this cell row is highlight."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"activeName"}</_components.code></_components.td><_components.td>{"string"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The style name of the table row highlight."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"colSpan"}</_components.code></_components.td><_components.td>{"number"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The value represents the number of columns to span."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"scope"}</_components.code></_components.td><_components.td>{"\"col\" | \"row\" | \"colgroup\" | \"rowgroup\""}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"The scope attribute specifies whether a header cell is a header for a column, row, or group of columns or rows."}</_components.td><_components.td>{"-"}</_components.td></_components.tr><_components.tr><_components.td><_components.code>{"onClick"}</_components.code></_components.td><_components.td>{"function"}</_components.td><_components.td>{"-"}</_components.td><_components.td>{"Click on the callback function of the cell."}</_components.td><_components.td>{"-"}</_components.td></_components.tr></_components.tbody></_components.table></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}



const __nextraPageOptions = {
  MDXContent,
  pageOpts: {"filePath":"pages/Web-Elements/Table.html.mdx","route":"/Web-Elements/Table.html","timestamp":1739774380000,"pageMap":[{"kind":"Folder","name":"Forms","route":"/Forms","children":[{"kind":"MdxPage","name":"Checkbox.html","route":"/Forms/Checkbox.html"},{"kind":"MdxPage","name":"Input.html","route":"/Forms/Input.html"},{"kind":"MdxPage","name":"Radio.html","route":"/Forms/Radio.html"},{"kind":"Meta","data":{"Input.html":"Input🔥","Checkbox.html":"Checkbox","Radio.html":"Radio"}}]},{"kind":"Folder","name":"Getting-Started","route":"/Getting-Started","children":[{"kind":"MdxPage","name":"Installation.html","route":"/Getting-Started/Installation.html"},{"kind":"MdxPage","name":"Usage.html","route":"/Getting-Started/Usage.html"},{"kind":"Meta","data":{"Installation.html":"Installation","Usage.html":"Usage"}}]},{"kind":"MdxPage","name":"index","route":"/"},{"kind":"Folder","name":"Navigation","route":"/Navigation","children":[{"kind":"MdxPage","name":"DropdownMenu.html","route":"/Navigation/DropdownMenu.html"},{"kind":"Meta","data":{"DropdownMenu.html":"DropdownMenu"}}]},{"kind":"Folder","name":"Other","route":"/Other","children":[{"kind":"MdxPage","name":"EmptyNotice.html","route":"/Other/EmptyNotice.html"},{"kind":"MdxPage","name":"Popovers.html","route":"/Other/Popovers.html"},{"kind":"Meta","data":{"EmptyNotice.html":"EmptyNotice🌈","Popovers.html":"Popovers🔈"}}]},{"kind":"Folder","name":"Web-Elements","route":"/Web-Elements","children":[{"kind":"MdxPage","name":"ModalDialog.html","route":"/Web-Elements/ModalDialog.html"},{"kind":"MdxPage","name":"Notification.html","route":"/Web-Elements/Notification.html"},{"kind":"MdxPage","name":"SelectInput.html","route":"/Web-Elements/SelectInput.html"},{"kind":"MdxPage","name":"Table.html","route":"/Web-Elements/Table.html"},{"kind":"MdxPage","name":"ToolTips.html","route":"/Web-Elements/ToolTips.html"},{"kind":"MdxPage","name":"Trees.html","route":"/Web-Elements/Trees.html"},{"kind":"Meta","data":{"ModalDialog.html":"ModalDialog🔥","SelectInput.html":"SelectInput🔥","ToolTips.html":"ToolTips","Table.html":"Table🔥","Trees.html":"Trees","Notification.html":"Notification"}}]},{"kind":"Meta","data":{"index":"Introduction","Getting-Started":{"title":"Getting-Started"},"--":{"type":"separator","title":"Components"},"Web-Elements":{"title":"Web Elements"},"Forms":{"title":"Forms"},"Navigation":{"title":"Navigation"},"Other":{"title":"Other"},"contact":{"title":"Source ↗","type":"page","href":"https://github.com/chennkaibin/pocko-ui","newWindow":true}}}],"flexsearch":{"codeblocks":true},"title":"Table",headings:__toc},
  pageNextRoute: "/Web-Elements/Table.html",
  nextraLayout: __nextra_layout,themeConfig: __nextra_themeConfig
}
if (process.env.NODE_ENV !== 'production') {
  __nextraPageOptions.hot = module.hot
  __nextraPageOptions.pageOptsChecksum = ''
}
if (typeof window === 'undefined') __nextraPageOptions.dynamicMetaModules = []

export default setupNextraPage(__nextraPageOptions)